import { render, staticRenderFns } from "./Parcel.vue?vue&type=template&id=6cba1eaf&scoped=true&"
import script from "./Parcel.vue?vue&type=script&lang=ts&"
export * from "./Parcel.vue?vue&type=script&lang=ts&"
import style0 from "./Parcel.vue?vue&type=style&index=0&id=6cba1eaf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba1eaf",
  null
  
)

export default component.exports